export default __webpack_public_path__ + "static/media/Beige-playlist-panels.3837b780.jpg";